@import '../../../responsive/responsive-mixin';
$sizes: 1024, 0;

ui-realestate-property-view {
  .no-results-message {
    margin-top: 30px;
  }

  .property-view-wrapper {
    @include responsive($sizes);

    display: block;
    margin-top: 25px;

    .view-switch {
      position: relative;
      display: flex;
      justify-content: center;
      margin-bottom: -25px;
      z-index: 1;

      .ui-button[variant|='primary'] {
        position: relative;
        z-index: 2;
      }

      .ui-button {
        &:first-of-type {
          margin-right: -4px;
        }
      }

      &::after {
        content: '';
        width: 100%;
        border-bottom: 1px solid $ui-grey-minus-1;
        position: absolute;
        top: 50%;
        z-index: -1;
      }
    }

    .ui-slider {
      .swiper-slide {
        .ui-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
    }

    &.list {
      ui-realestate-property-info {
        display: flex;
        flex-flow: row wrap;
        gap: 30px;

        .ui-slider {
          .swiper-slide {
            height: 250px;
          }
        }

        .property__images,
        .property__info {
          width: 100%;
        }

        @include breakpoint($medium) {
          .ui-slider {
            .swiper-slide {
              height: 280px;
            }
          }

          .property__images {
            width: 40%;
          }

          .property__info {
            width: calc(60% - 30px);
          }
        }
      }
    }
  }
}
